const journalTypes = {
  addition: 'addition',
  settlement: 'settlement',
};

const allJournalTypes = Object.values(journalTypes);

export { journalTypes, allJournalTypes };
